<template>
  <div class="shop_box">
    <!-- <div class="temp_t"> -->
      <div class="temp_t_btn" @click="openDialog">新增店铺</div>
      <!-- <div> -->
        <!-- <el-input class="temp_t_search"
          placeholder="中文名称、英文名称或16进制值"
          v-model="searchForm.keyword">
          <span slot="suffix" @click="tableSearch">
            搜索 <img src="@/assets/images/search.png">
          </span>
        </el-input> -->
      <!-- </div> -->
    <!-- </div> -->
    <el-form inline :model="searchForm" class="form_inline_search">
      <el-form-item label="关键词">
        <el-input v-model="searchForm.keyword"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchForm.status">
          <el-option label="启用" :value="1"></el-option>
          <el-option label="禁用" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-button class="search_btn" @click="tableSearch">搜索</el-button>
    </el-form>
    <el-table
      :data="tableData"
      class="main_table">
      <!-- <el-table-column
        type="selection"
        width="55" /> -->
      <el-table-column
        prop="name"
        label="店铺名称" />
      <el-table-column
        prop="status"
        label="状态">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="changeStatus(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间" />
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" style="color: #F72D2D" @click="handleDelete(scope.row.id)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="main_pagination"
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="searchForm.limit"
      :total="tableTotal">
    </el-pagination>
    <el-dialog class="main_dialog" :show-close="false" :title="ruleForm.id ? '编辑店铺' : '新增店铺'" width="470px" :visible.sync="dialogVisible">
      <el-form :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" hide-required-asterisk>
        <el-form-item label="店铺名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请填写店铺名称"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch
            v-model="ruleForm.status"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <el-button class="dialog_confirm" size="small" @click="handleSubmitForm">确 定</el-button>
      <el-button class="dialog_cancel" size="small" @click="dialogVisible = false">取 消</el-button>
    </el-dialog>
  </div>
</template>
<script>
import { shopGetList, shopCreate, shopUpdate, shopDelete, shopStatus } from '@/api/shop'
export default {
  name: "shop",
  data () {
   return {
    searchForm: {
      keyword: '',
      status: '',
      page: 1,
      limit: 10
    },
    tableData: [],
    tableTotal: 0,

    dialogVisible: false,
    ruleForm: {
      name: '',
      status: 1
    },
    rules: {
      name: [{required: true, message: '请填写店铺名称', trigger: 'blur'}]
    }
   }
  },
  created() {
    this.getShopList()
  },
  methods:{
    openDialog() {
      if(this.ruleForm.id) {
        delete this.ruleForm.id
      }
      this.ruleForm.name = ''
      this.ruleForm.status = 1
      this.dialogVisible = true
      
    },
    handleEdit(row) {
      this.ruleForm.id = row.id
      this.ruleForm.name = row.name
      this.ruleForm.status = row.status
      this.dialogVisible = true
    },
    handleSubmitForm() {
      this.$refs.ruleForm.validate(valid => {
        if(valid) {
          if(this.ruleForm.id) {
            shopUpdate(this.ruleForm.id, this.ruleForm).then(res => {
              this.$message.success('编辑店铺成功')
              this.dialogVisible = false
              this.getShopList()
            })
          }else {
            shopCreate(this.ruleForm).then(res => {
              this.$message.success('新增店铺成功')
              this.dialogVisible = false
              this.getShopList()
            })
          }
          
        }
      })
      // this.$router.push('/teamResource/template/detail')
    },
    handleDelete(id) {
      this.$confirm('是否删除该店铺?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        shopDelete(id).then(res => {
          this.$message.success('删除店铺成功')
          this.getShopList()
        })
      })
    },
    changeStatus(row) {
      shopStatus({id: row.id, status: row.status == 1 ? 0 : 1}).then(res => {
        this.$message.success(row.status == 1 ? '店铺已禁用！': '店铺已启用！')
        this.$set(row, 'status', row.status == 1 ? 0 : 1)
      }).catch(() => {
        this.$set(row, 'status', row.status)
      })
    },
    getShopList() {
      shopGetList(this.searchForm).then(res => {
        this.tableData = res.data.data
        this.tableTotal = res.data.total
      })
    },
    tableSearch() {
      this.searchForm.page = 1
      this.getShopList()
    },
    handleCurrentChange(val) {
      this.searchForm.page = val
      this.getShopList()
    }
  }
}
</script>
<style lang="scss" scoped>
.shop_box {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 24px 16px;
  .temp_t_btn {
    border-radius: 8px;
    background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
    font-size: 20px;
    font-weight: 500;
    color: #F7F8FA;
    width: 171px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    margin-bottom: 24px;
    cursor: pointer;
  }
}
</style>